import SelfReadingDatesResult from 'features/requirements/models/SelfReadingDatesResult';
import Alert from 'features/shared/alerts/components/Alert';
import IContentDialogService from 'features/shared/components/contentDialog/IContentDialogService';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  datesResult: SelfReadingDatesResult;
  onCloseDialog?: () => Promise<void>;
}

const SelfReadingTypeErrorSubDialog = ({ datesResult, onCloseDialog }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // DI
  const dialogService = useInjection<IContentDialogService>(IocTypes.ContentDialogService);

  // helpers
  const getButtonText = (): string => {
    if (datesResult.dates?.warning && !datesResult.dates.error) {
      return tLabels("selfReadingTypeErrorSubDialog.continue")
    } else {
      return tLabels("selfReadingTypeErrorSubDialog.changeReason");
    }   
  }

  // handlers
  const closeDialogHandler = () => { 
    if (onCloseDialog) {
      onCloseDialog();
    }
    dialogService.closeDialog();
  }

  // sub renders
  const renderAlerts = () => {
    // if dates prop is defined in this context => error or warning is must be filled
    if (datesResult.dates) {
      if (datesResult.dates.error) {
        return (
          <>
            <Alert alertObj={{alertType: "Danger", message: datesResult.dates.error}} />
            {renderWarning()}
          </>
        );
      } 

      return <>{renderWarning()}</>
    } 

    return <Alert alertObj={{alertType: "Danger", message: tLabels("selfReadingTypeErrorSubDialog.dangerMessage")}} />
  }

  const renderWarning = () => {
    if (datesResult.dates?.warning) {
      return <Alert alertObj={{alertType: "Warning", message: datesResult.dates.warning}} />;
    }
  }

  // render
  return (
    <>
      <div className="p-4">
        {renderAlerts()}
      </div>
      <div className="d-flex justify-content-end px-4 pb-4">
        <button className="btn btn-primary" onClick={closeDialogHandler}>
          {getButtonText()}
        </button>
      </div>
    </>
  )
}

export default SelfReadingTypeErrorSubDialog;
